import { render, staticRenderFns } from "./security-setting-inner.vue?vue&type=template&id=d7663fe6"
import script from "./security-setting-inner.vue?vue&type=script&lang=js"
export * from "./security-setting-inner.vue?vue&type=script&lang=js"
import style0 from "./security-setting-inner.vue?vue&type=style&index=0&id=d7663fe6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports